import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { I18nProvider } from './context/I18nContext';
import { Header } from './components/common/Header';
import { Footer } from './components/common/Footer';
import { HomePage } from './pages/HomePage';
import { AppsIndexPage } from './pages/AppsIndexPage';
import { AppDetailPage } from './pages/AppDetailPage';
import { SupportIndexPage } from './pages/SupportIndexPage';
import { AppSupportPage } from './pages/AppSupportPage';
import { AboutPage } from './pages/AboutPage';
import { ContactPage } from './pages/ContactPage';
import { NotFoundPage } from './pages/NotFoundPage';

// Helper component that scrolls window to (0, 0) on every route transition
const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export const App: React.FC = () => {
  return (
    <HelmetProvider>
      <I18nProvider>
        <BrowserRouter>
          <ScrollToTop />
          <div className="min-h-screen flex flex-col bg-white text-slate-900">
            <Header />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/apps" element={<AppsIndexPage />} />
                <Route path="/apps/:appSlug" element={<AppDetailPage />} />
                <Route path="/support" element={<SupportIndexPage />} />
                <Route path="/support/:appSlug" element={<AppSupportPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </BrowserRouter>
      </I18nProvider>
    </HelmetProvider>
  );
};

export default App;
